exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* -- Module -- */\n/* -- Mixins -- */\n.content-module .learn-structure {\n  border-bottom: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/src/app/module/module.component.scss
// module id = ../../../../../src/app/module/module.component.scss
// module chunks = 1